import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useAuth } from "../../../hooks/useAuth";
import { Button } from "../../../components/ui";
import GifteeAppBottomNav from "../../giftees/components/GifteeAppBottomNav.jsx";
import { discardGuestSession } from "../guestSession.js";
import styles from "../styles/SettingsScreen.module.css";

export default function SettingsScreen() {
  const { logout, isGuest } = useAuth();
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(false);
  const [confirmExitTrial, setConfirmExitTrial] = useState(false);

  const handleLogout = async () => {
    if (loggingOut) return;
    setLoggingOut(true);
    try {
      await logout();
      navigate("/auth", { replace: true });
    } finally {
      setLoggingOut(false);
    }
  };

  const handleExitTrial = async () => {
    if (loggingOut) return;
    setLoggingOut(true);
    try {
      await discardGuestSession();
      navigate("/auth", { replace: true });
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <div className={styles.shell}>
      <main className={styles.content}>
        <div className={styles.header}>
          <h1 className={styles.headerTitle}>Settings</h1>
        </div>
        {isGuest ? (
          <div className={styles.actions}>
            <p className={styles.guestNote}>
              You&apos;re trying Gift Gaff. Create an account to save your
              giftees, occasions, and reminders.
            </p>
            <div className={styles.actionStack}>
              <Button
                variant="primary"
                size="md"
                layout="text"
                fullWidth
                label="Create account"
                onClick={() => navigate("/auth?intent=create-account")}
              />
              <Button
                variant="secondary"
                size="md"
                layout="text"
                fullWidth
                label="Log in to an existing account"
                onClick={() => navigate("/auth?intent=login")}
              />
              {confirmExitTrial ? (
                <>
                  <p className={styles.guestNote}>
                    Exiting deletes the giftees you added while trying Gift Gaff.
                  </p>
                  <Button
                    variant="secondary"
                    size="md"
                    layout="text"
                    fullWidth
                    label={
                      loggingOut ? "Exiting\u2026" : "Delete and exit trial"
                    }
                    disabled={loggingOut}
                    onClick={handleExitTrial}
                  />
                  <button
                    type="button"
                    className={styles.textAction}
                    disabled={loggingOut}
                    onClick={() => setConfirmExitTrial(false)}
                  >
                    Keep trying Gift Gaff
                  </button>
                </>
              ) : (
                <button
                  type="button"
                  className={styles.textAction}
                  onClick={() => setConfirmExitTrial(true)}
                >
                  Exit trial
                </button>
              )}
            </div>
          </div>
        ) : (
          <div className={styles.actions}>
            <Button
              variant="primary"
              size="md"
              layout="text"
              fullWidth
              label="Log out"
              disabled={loggingOut}
              onClick={handleLogout}
            />
          </div>
        )}
      </main>
      <GifteeAppBottomNav />
    </div>
  );
}
